import { get } from 'lodash-es';
import { getParsedExpectedServiceDays } from '@/util/helper/dataParser';
import { getParsedDateTime } from '@/util/helper/dateTime';
import { DATE_TIME_FORMAT_MAP } from '@/config/dateTime';
import { getPartTimeExpectedEndTime } from '../../helper/option';
export class CareOrderBabyFormForDateAndTimePage {
    #careOrderBabyForm;
    #maxServiceDays;
    constructor({ careOrderBabyForm, maxServiceDays, }) {
        this.#careOrderBabyForm = careOrderBabyForm;
        this.#maxServiceDays = maxServiceDays;
    }
    get parsedAllDayExpectedStartTime() {
        const timeSlotList = this.#careOrderBabyForm.timeSlotList;
        const allDayExpectedStartTime = get(timeSlotList[0], 'expectedStartTime');
        if (!allDayExpectedStartTime)
            return '';
        const { parsedDateTime } = getParsedDateTime({
            dateTime: allDayExpectedStartTime,
            format: DATE_TIME_FORMAT_MAP.DATE_TIME,
        });
        return parsedDateTime;
    }
    get parsedAllDayExpectedServiceDays() {
        const timeSlotList = this.#careOrderBabyForm.timeSlotList;
        const allDayExpectedServiceDays = get(timeSlotList[0], 'expectedServiceDays');
        if (!allDayExpectedServiceDays)
            return '';
        const { parsedExpectedServiceDays } = getParsedExpectedServiceDays({
            expectedServiceDays: allDayExpectedServiceDays,
            maxServiceDays: this.#maxServiceDays,
        });
        return parsedExpectedServiceDays;
    }
    get parsedPartTimeExpectedStartTime() {
        const partTimeExpectedStartTime = this.#careOrderBabyForm.partTimeExpectedStartTime;
        if (!partTimeExpectedStartTime)
            return '';
        const { parsedDateTime } = getParsedDateTime({
            dateTime: partTimeExpectedStartTime,
            format: DATE_TIME_FORMAT_MAP.TIME,
        });
        return parsedDateTime;
    }
    get parsedPartTimeExpectedEndTime() {
        const partTimeExpectedStartTime = this.#careOrderBabyForm.partTimeExpectedStartTime;
        const partTimeExpectedServiceHours = this.#careOrderBabyForm.partTimeExpectedServiceHours;
        if (!partTimeExpectedStartTime || !partTimeExpectedServiceHours)
            return '';
        const partTimeExpectedEndTime = getPartTimeExpectedEndTime({
            expectedStartTime: partTimeExpectedStartTime,
            expectedServiceHours: partTimeExpectedServiceHours,
        });
        const { parsedDateTime } = getParsedDateTime({
            dateTime: partTimeExpectedEndTime,
            format: DATE_TIME_FORMAT_MAP.TIME,
        });
        return parsedDateTime;
    }
    get parsedPartTimeTimeSlotList() {
        const timeSlotList = this.#careOrderBabyForm.timeSlotList;
        const parsedTimeSlotList = timeSlotList
            .map((timeSlot) => {
            const expectedStartTime = timeSlot.expectedStartTime;
            const { parsedDateTime } = getParsedDateTime({
                dateTime: expectedStartTime,
                format: DATE_TIME_FORMAT_MAP.DATE_WITHOUT_DAY,
            });
            return parsedDateTime;
        })
            .join(', ');
        return parsedTimeSlotList;
    }
}
